import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'
import { COLORS } from '../data/enums'

export default function FaceFeature({
  scaleX,
  scale,
  gradient,
  pupil,
  rotation = 0,
  spacing = 0,
  verticalOffset,
  outline,
  showEyeLiner,
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftPupilTransformOrigin = '16.79 13.9'
  const rightPupilTransformOrigin = '42.79 13.9'
  return (
    <>
      <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
        {/* LEFT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${-spacing})`} transform-origin={leftPupilTransformOrigin}>
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            <path
              className="cls-2"
              d="M23.8,17.94s-.46-9.96-8.2-9.68c-6.44,.24-7.8,8.38-7.8,8.38,0,0,5.81,7.18,16,1.3Z"
              fill={COLORS.WHITE}
            />
            <path
              className="cls-3"
              d="M16.1,20.74c-5.54,0-8.65-3.73-8.69-3.79l-.14-.17,.04-.22c.01-.09,1.5-8.55,8.28-8.79,8.17-.31,8.71,10.05,8.72,10.15v.3l-.25,.15c-3.02,1.75-5.69,2.37-7.95,2.37Zm-7.76-4.24c.95,1.04,6.18,6.06,14.94,1.16-.14-1.64-1.17-9.1-7.66-8.9-5.37,.2-7.01,6.46-7.28,7.74Z"
              fill={outline}
            />
          </g>
          <path
            className="cls-1"
            d="M16.8,18.89c2.76,0,5-2.24,5-5s-2.24-5-5-5-5,2.24-5,5,2.24,5,5,5Z"
            fill={`url(#${randomGradientId1})`}
          />
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            <path
              className="cls-4"
              d="M16.79,16.4c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5-2.5,1.12-2.5,2.5,1.12,2.5,2.5,2.5Z"
              fill={pupil}
            />
            {showEyeLiner && (
              <path d="M24.31,18.22c-.57-2.23-1.37-4.39-2.61-6.14-2.44-3.69-7.68-3.87-10.72-.83-1.56,1.48-2.76,3.44-3.71,5.54,.27-2.3,1.15-4.59,2.73-6.47,2.38-3.01,7.09-3.89,10.34-1.74,3.1,2.1,4.2,6.18,3.98,9.65h0Z" />
            )}
          </g>
          <path
            className="cls-2"
            d="M18.46,13.05c.46,0,.83-.37,.83-.83s-.37-.83-.83-.83-.83,.37-.83,.83,.37,.83,.83,.83Z"
            fill={COLORS.WHITE}
          />
        </g>
        {/* RIGHT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${spacing})`} transform-origin={rightPupilTransformOrigin}>
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path
              className="cls-2"
              d="M35.8,17.94s.46-9.96,8.2-9.68c6.44,.24,7.8,8.38,7.8,8.38,0,0-5.81,7.18-16,1.3Z"
              fill={COLORS.WHITE}
            />
          </g>
          <path
            className="cls-5"
            d="M42.8,18.89c2.76,0,5-2.24,5-5s-2.24-5-5-5-5,2.24-5,5,2.24,5,5,5Z"
            fill={`url(#${randomGradientId2})`}
          />
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path
              className="cls-4"
              d="M42.79,16.4c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5-2.5,1.12-2.5,2.5,1.12,2.5,2.5,2.5Z"
              fill={pupil}
            />
            <path
              className="cls-3"
              d="M43.5,20.74c-2.26,0-4.92-.62-7.95-2.37l-.26-.15v-.3c.02-.1,.56-10.45,8.73-10.15,6.77,.25,8.26,8.71,8.28,8.79l.04,.22-.14,.17c-.04,.05-3.15,3.79-8.69,3.79Zm-7.18-3.08c8.76,4.89,13.99-.12,14.94-1.16-.28-1.28-1.91-7.54-7.28-7.74-6.49-.22-7.52,7.26-7.66,8.9Z"
              fill={outline}
            />
            {showEyeLiner && (
              <path d="M52.33,16.77c-1.48-2.99-3.27-5.91-6.34-7.18-2.91-1.17-6.38-.2-8.14,2.46-1.25,1.76-2.04,3.93-2.57,6.17-.11-2.31,.33-4.7,1.5-6.85,1.76-3.48,6.31-4.96,9.86-3.35,3.42,1.48,5.35,5.28,5.69,8.75h0Z" />
            )}
          </g>
          <path
            className="cls-2"
            d="M44.46,13.05c.46,0,.83-.37,.83-.83s-.37-.83-.83-.83-.83,.37-.83,.83,.37,.83,.83,.83Z"
            fill={COLORS.WHITE}
          />
        </g>
      </g>

      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="16.8"
          y1="178.9"
          x2="16.8"
          y2="189.21"
          gradientTransform="translate(0 198) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          y1="178.9"
          y2="189.21"
          x1="42.8"
          x2="42.8"
          gradientTransform="translate(0 198) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </>
  )
}
